var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHomeActive = function SvgHomeActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 23 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#26BAB9",
    d: "m19.622 7.672-6.353-5.078c-.98-.788-2.566-.788-3.538-.01L3.379 7.673c-.715.569-1.174 1.77-1.018 2.668l1.22 7.297c.22 1.301 1.466 2.355 2.786 2.355h10.267c1.31 0 2.566-1.063 2.786-2.355l1.22-7.297c.146-.898-.312-2.1-1.018-2.668M11.5 14.208a2.293 2.293 0 1 1 .002-4.585 2.293 2.293 0 0 1-.002 4.585"
  })));
};
export default SvgHomeActive;